export default function IconZRMMobileLogo() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="#006aff" viewBox="0 0 2409.5 232.53" width="232" height="22.38">
      <title>Zillow Rental Manager</title>
      <path
        className="a"
        d="M2324.3,129.64h-84.48c.47,21.06,13.49,33.37,34.31,33.37,14.44,0,24.38-5.68,28.87-16.09h20.59C2319.8,167,2299.69,181,2274.13,181c-33.6,0-54.66-22.24-54.66-57.5,0-34.55,21.3-57.27,53.71-57.27,30.77,0,51.59,21.3,51.59,51.35A112,112,0,0,1,2324.3,129.64Zm-19.64-15.85c0-19.17-11.83-31-31.71-31s-32.18,12.54-33.13,31Z"
      />
      <path
        className="a"
        d="M1844.78,67.81h20.62V88c5.93-14,19.2-23,38.16-23,26.78,0,40.53,15.64,40.53,44.79v67.31h-20.38v-58.3c0-24.41-8.06-36-27.5-36-20.38,0-30.81,14.45-30.81,36.49v57.83h-20.62Z"
      />
      <path
        className="a"
        d="M1705.92,122.66c0-32.33,20.67-57.76,54.66-57.76,17.36,0,31.62,8.79,38.51,22.34V67.75h20.44V177.32h-20.44V158.07c-6.89,13.55-22.58,22.11-39,22.11C1725.17,180.18,1705.92,155,1705.92,122.66Zm94.12,0c0-21.16-13.07-39.22-37.08-39.22-22.58,0-36.6,16.64-36.6,39.22,0,22.34,14,39,36.6,39C1787,161.64,1800,143.81,1800,122.66Z"
      />
      <path
        className="a"
        d="M1959.22,122.66c0-32.33,20.68-57.76,54.67-57.76,17.35,0,31.61,8.79,38.5,22.34V67.75h20.44V177.32h-20.44V158.07c-6.89,13.55-22.58,22.11-39,22.11C1978.47,180.18,1959.22,155,1959.22,122.66Zm94.12,0c0-21.16-13.07-39.22-37.08-39.22-22.58,0-36.6,16.64-36.6,39.22,0,22.34,14,39,36.6,39C2040.27,161.64,2053.34,143.81,2053.34,122.66Z"
      />
      <path
        className="a"
        d="M658.82,67.39h35l10.14,33.15c3.39,11,6.33,21.28,9.08,31.75h.43c2.89-10.24,5.87-21.15,9.22-31.75L733.3,67.4h25.84l10.45,33.14c3.53,11.36,6.16,21.26,9,31.76h.45c2.74-10.5,5.73-20.65,9.08-31.75L798.29,67.4H830.8L795.62,177h-32l-8.71-27.52c-3.35-10.78-6.54-21.76-9.28-31.9h-.43c-2.74,10.14-5.94,20.71-9.48,31.72L726.84,177H694.27Z"
      />
      <rect className="a" x="423.29" y="9.53" width="35.41" height="167.43" />
      <rect className="a" x="484.93" y="9.52" width="35.41" height="167.43" />
      <path
        className="a"
        d="M537.87,122.55c0-33.28,26.84-57.94,59.69-57.94,32.51,0,59.37,24.66,59.37,57.94s-26.85,58.05-59.37,58.05c-32.85,0-59.69-24.67-59.69-58m85.09,0c0-16.3-11.63-27.4-25.4-27.4-14.1,0-25.74,11.1-25.74,27.4S583.45,150,597.56,150c13.77,0,25.4-11,25.4-27.4"
      />
      <polygon
        className="a"
        points="218.46 25.02 218.46 57.3 281.05 57.3 281.27 57.74 216.57 167.67 216.57 176.95 338.46 176.95 338.46 144.73 270.75 144.73 270.52 144.28 335.18 34.37 335.13 34.37 335.13 25.02 218.46 25.02"
      />
      <path
        className="a"
        d="M378.74,12.53A20.09,20.09,0,0,1,398.9,32.4a20.16,20.16,0,0,1-40.32,0,20.09,20.09,0,0,1,20.16-19.87M361,67.4h35.4V177H361Z"
      />
      <path
        className="a"
        d="M106.68,46.61a1.45,1.45,0,0,1,1.69.56c2.89,3,12.24,13.51,14.8,16.39a1,1,0,0,1-.06,1.34L123,65c-17.41,14.75-36.61,35.41-47.19,50.07-.22.32,0,.33.13.26,19.28-9.24,65-24.61,85.16-29V63.62L80.62,0,0,63.62V95.08C24.57,79.23,80.93,54.14,106.68,46.61Z"
      />
      <path
        className="a"
        d="M45.67,158.56a1.33,1.33,0,0,1-1.76-.19L28.17,141.09c-.45-.45-.48-.72,0-1.54,10.93-17.47,33.54-44.93,48.2-56.71.25-.21.18-.4-.14-.28C60.54,88.4,15.66,109.87,0,119.72V177H161.1V115.29C138.73,120.16,74.67,142.11,45.67,158.56Z"
      />
      <path
        className="a"
        d="M853.51,51.35A5.1,5.1,0,0,0,848.25,46h-5.66V61.33h2.55V56.72h2.47l2.81,4.61h2.84l-3-5A5.12,5.12,0,0,0,853.51,51.35Zm-5.42,3.12h-3V48.24h3a3.12,3.12,0,0,1,0,6.23Z"
      />
      <path
        className="a"
        d="M847.49,40.65a13.26,13.26,0,1,0,13.25,13.27h0A13.26,13.26,0,0,0,847.49,40.65Zm0,24A10.72,10.72,0,1,1,858.2,53.9h0A10.72,10.72,0,0,1,847.49,64.62Z"
      />
      <path
        className="a"
        d="M1530.22,25.27h22.5l54.56,121.35,54.56-121.35h22.27V176.93h-20.44V69.68L1615.5,176.93h-16.44l-48.4-108v108h-20.44Z"
      />
      <path
        className="a"
        d="M2202.45,67.77V175.14c0,21-6.7,36.83-19.13,46.39-9.33,6.94-22.24,10.29-38,10.29-15.06,0-29.17-3.59-39.21-10.77-9.81-6.93-15.79-17.21-16.27-29.17h21.77c1.43,12.91,12.43,22.48,33.48,22.48,23.91,0,36.82-11.48,36.82-37.78V158.64c-6.93,13.87-23.19,22.24-39.22,22.24-33.72,0-54.52-25.35-54.52-57.87,0-32.76,22.24-58.11,55-58.11,17,0,31.81,8.37,38.74,22.48V67.77ZM2182.84,123c0-21.76-14.11-39.46-37.31-39.46-22,0-36.82,16.74-36.82,39.46,0,22.48,15.06,39.22,36.82,39.22C2168.73,162.23,2182.84,144.53,2182.84,123Z"
      />
      <path
        className="a"
        d="M2346.3,67.58h20.83V91.71c4.31-18.67,18.43-26.81,32.31-26.81a40.85,40.85,0,0,1,10.06,1V85a48.48,48.48,0,0,0-10.3-.72c-21.78,0-32.07,19.87-32.07,44.53v48.11H2346.3Z"
      />
      <path
        className="a"
        d="M1098.08,129.64H1013.6c.48,21.06,13.49,33.37,34.32,33.37,14.43,0,24.37-5.68,28.86-16.09h20.59c-3.78,20.11-23.9,34.07-49.45,34.07-33.61,0-54.67-22.24-54.67-57.5,0-34.55,21.3-57.27,53.72-57.27,30.76,0,51.58,21.3,51.58,51.35A112,112,0,0,1,1098.08,129.64Zm-19.64-15.85c0-19.17-11.83-31-31.71-31s-32.18,12.54-33.13,31Z"
      />
      <path
        className="a"
        d="M1117.77,67.81h20.63V88c5.92-14,19.19-23,38.15-23,26.78,0,40.53,15.64,40.53,44.79v67.31H1196.7v-58.3c0-24.41-8.06-36-27.5-36-20.38,0-30.8,14.45-30.8,36.49v57.83h-20.63Z"
      />
      <path
        className="a"
        d="M1298.36,158.2v18.22a93.44,93.44,0,0,1-18.46,1.65c-12.78,0-33.36-2.36-33.36-37.62V84.84h-19.65V67.56h19.65V33h20.58V67.56h27.45V84.84h-27.45V136c0,20.83,7.1,23.67,17.51,23.67A79,79,0,0,0,1298.36,158.2Z"
      />
      <path
        className="a"
        d="M1309.28,122.66c0-32.33,20.68-57.76,54.67-57.76,17.35,0,31.61,8.79,38.5,22.34V67.75h20.44V177.32h-20.44V158.07c-6.89,13.55-22.58,22.11-39,22.11C1328.53,180.18,1309.28,155,1309.28,122.66Zm94.12,0c0-21.16-13.07-39.22-37.08-39.22-22.58,0-36.6,16.64-36.6,39.22,0,22.34,14,39,36.6,39C1390.33,161.64,1403.4,143.81,1403.4,122.66Z"
      />
      <path className="a" d="M1447.93,25.27h20.59v152h-20.59Z" />
      <path
        className="a"
        d="M951.1,125.54c20.09-6.87,34-25.18,34-48.59,0-30.15-22.79-51.74-52.08-51.74H872V177.3h21.3V128.74h34.78l30.22,48.56h24.62l-31.88-51.63Zm-57.79-81h36.82c18.39,0,33.71,12.49,33.71,32.37,0,19.67-15.32,32.16-33.71,32.16H893.31Z"
      />
    </svg>
  );
}
